<template>
    <div class="add-new-client">
        <md-dialog :md-active.sync="showDialog" >
          <validation-observer v-slot="{ handleSubmit }" tag="div">
            <form @submit.prevent="handleSubmit(addNewCampaign)" class="form">
            <md-dialog-title>
                <span>New Campaign for {{brand.name}}</span>
                <button class="btn btn--close" @click="cancel"></button>
            </md-dialog-title>                          
            <div class="form__content" >
              
                <ValidationProvider :rules="{required :true, min:3}" v-slot="{ errors }" tag="div">
                  <md-field>                    
                    <label>Campaign name</label>
                    <md-input v-model="campaign.name" />                    
                  </md-field>
                  <div class="form__error">{{ errors[0] }}</div>
                </ValidationProvider>
              
            </div>                          
            <md-dialog-actions>
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                </div>
                <div class="md-layout-item text-right">
                 <md-button class="md-primary modal-save-btn" type="submit">Save Campaign</md-button>
                </div>
              </div>
            </md-dialog-actions>
            </form>
          </validation-observer>
        </md-dialog>
            
        <button class="btn-add-new-campaign-dash" @click="showDialog = true">
            add new campaign
        </button>
    </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {min, required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "Campaign name is required."
});
extend('min', {
  ...min,
  message: "This field should contain at least 3 letters"
});

export default {
  props:['brand'],
  mixins: [apiHandlerMI],
  data(){
    return{
      showDialog: false,
      active: false,
      campaign: {
        name: '',
        staus: 'live'
      },
      error: {},

      
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
    methods:{
      
      addNewCampaign(){
        var _this = this;
        this.campaign.brand_id = this.brand.id;
        this.post('campaign',this.campaign,{},function(){
          //console.log(resp.data);
          _this.campaign = {
            name: '',
            status : 'live'
          };
          if (_this.$parent.refreshBrand)
            _this.$parent.refreshBrand();
          _this.showDialog = false
        },function(resp){
          //console.log(resp);
          _this.error = resp.data.error;
          this.$forceUpdate();
        })
      },
     
      cancel(){
        this.showDialog = false
        
      }
    }
 }

</script>